<template>
  <div :class="['form-element', hidden && 'd-none']">
    <FormLabel
      v-if="label"
      v-bind="{
        label,
        required,
        disabled,
        description,
        descriptionType,
        dirty,
        error,
        id,
        status
      }"
      tag="legend"
    />
    <ul v-if="instructors && instructors.length" class="form-sy-instructors__list">
      <li v-for="instructor in instructors" :key="instructor._id">
        {{ getFullName(instructor) }}
        <template v-if="instructor.email"> ({{ instructor.email }})</template>
        <AppBadge class="ml-2">{{ instructor.type }}</AppBadge>
      </li>
    </ul>
    <div v-else class="text-muted">No instructors</div>
  </div>
</template>

<script>
import FormMixin from '@/components/Forms/FormMixin'
import FormLabel from '@/components/Forms/FormLabel'
import { defineComponent } from '@vue/composition-api'
import { getFullName } from '@/utils/user'
import useInstructors from '@sy/client/composables/useInstructors'

export default defineComponent({
  mixins: [ FormMixin ],
  components: { FormLabel },
  setup () {
    const { instructors, fetchByIds } = useInstructors()
    return { instructors, fetchByIds }
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      async handler (newVal) {
        if (newVal && newVal.length) {
          await this.fetchByIds(newVal)
        }
      },
    },
  },
  methods: {
    getFullName: getFullName,
  },
})
</script>

<style scoped>
  .form-sy-instructors__list {
    padding-inline-start: 14px;
  }
</style>
